import { getObjectSelectedFields, getObjectSelectedData } from '@domain/object-selected';
import {
    editUserConfig,
    getUserConfigData,
    hasConfigForSelectedObject,
    getConfigForSelectedObject,
} from '@domain/user-config';
import { createMiddleware } from '@shared/redux/create-middleware';
import {
    CHANGE_DASHBOARD_FILTER,
    GET_INITIAL_DASHBOARD_FILTERS,
    getDashboardFilters,
    setInitialDashboardFilters,
} from './dashboard-filters.state';
import { validateAndFormatDashboardFilters } from './dashboard-filters.validation';
import { DashboardFiltersProps } from './dashboard-filters.types';
import { newRanges } from './dashboard-filters.utils';

export const dashboardFiltersMiddleware = createMiddleware({
    [CHANGE_DASHBOARD_FILTER]: async (state, action) => {
        const currentFilters = getDashboardFilters(state);
        const dashboardFilters = getUserConfigData(state).DASHBOARD_FILTERS || {};
        const objectSelectedData = getObjectSelectedData(state);
        const { entity, id } = getObjectSelectedFields(objectSelectedData);

        const entityFilter = dashboardFilters[entity] || {};

        const newEntityFiltersForId = {
            ...currentFilters,
            ...action.payload,
        };

        const formattedFilters = await validateAndFormatDashboardFilters(newEntityFiltersForId);

        const newRangesChanged = action.payload.ranges
            ? action.payload.ranges
            : dashboardFilters.userLevel?.ranges;

        const newFilters = {
            ...dashboardFilters,
            [entity]: {
                ...entityFilter,
                [id]: formattedFilters,
            },
            userLevel: {
                ...dashboardFilters.userLevel,
                ranges: newRangesChanged,
            },
        };

        return editUserConfig({
            configs: {
                DASHBOARD_FILTERS: newFilters,
            },
        });
    },
    [GET_INITIAL_DASHBOARD_FILTERS]: async (state) => {
        const objectSelectedData = getObjectSelectedData(state);

        const newFiltersClientOrAccount = await
        newFiltersByClientOrAccount(state, objectSelectedData);

        const { ranges } = getUserLevelFilters(state);

        if (Array.isArray(newFiltersClientOrAccount)
            && newFiltersClientOrAccount.length === 0) return [];

        const newFilters = {
            ...newFiltersClientOrAccount,
            ranges: { ...ranges },
        };

        return setInitialDashboardFilters(newFilters);
    },
});

const getUserLevelFilters = (state) => {
    const userLevelRanges = state.userConfig.data.DASHBOARD_FILTERS?.userLevel?.ranges;
    const newFilters = {
        ranges: userLevelRanges
            ? newRanges(userLevelRanges).ranges
            : state.dashboard.dashboardFilters.ranges,
    };

    return newFilters;
};

const newFiltersByClientOrAccount = async (state, objectSelectedData) => {
    const { entity, id } = getObjectSelectedFields(objectSelectedData);

    if (!hasConfigForSelectedObject(state, 'DASHBOARD_FILTERS', entity, id)) return [];

    const filters = getConfigForSelectedObject(state, 'DASHBOARD_FILTERS', entity, id);
    const formattedFilters: DashboardFiltersProps = await validateAndFormatDashboardFilters(
        filters,
    );

    return formattedFilters;
};
